import { Injector, Component, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { LogoService } from '@app/shared/common/logo/logo.service';

@Component({
    templateUrl: './default-logo.component.html',
    selector: 'default-logo',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DefaultLogoComponent extends AppComponentBase implements OnInit {
    @Input() customHrefClass = '';


    defaultLogoUrl: string;
    defaultSmallLogoUrl: string;
    tenantLogoUrl: string;
    tenantSmallLogoUrl: string;

    constructor(
        injector: Injector,
        private _logoService: LogoService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.setLogoUrls();
    }

    private setLogoUrls(): void {        
        // this.defaultLogoUrl = this._logoService.getDefaultLogoUrl();
        this.defaultLogoUrl = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-light.jpg';
        this.defaultSmallLogoUrl = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-dark.png';
        
        // this.tenantLogoUrl = this._logoService.getLogoUrl();
        this.tenantLogoUrl = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-light.jpg';
        this.tenantSmallLogoUrl = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-dark.png';
    }
}